function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7903 17.7038H11.6108C11.2488 17.7038 10.9551 17.4101 10.9551 17.0482C10.9551 16.6862 10.9551 4.29643 10.9551 3.93449C10.9551 3.57255 11.2488 3.27881 11.6108 3.27881H20.7903C21.1523 3.27881 21.446 3.57255 21.446 3.93449V17.0482C21.446 17.4101 21.1523 17.7038 20.7903 17.7038Z",
  fill: "#ECEFF1"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2335 7.21298H11.6108C11.2488 7.21298 10.9551 6.91923 10.9551 6.55729C10.9551 6.19536 11.2488 5.90161 11.6108 5.90161H14.2335C14.5954 5.90161 14.8892 6.19536 14.8892 6.55729C14.8892 6.91923 14.5954 7.21298 14.2335 7.21298Z",
  fill: "#388E3C"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2335 9.83566H11.6108C11.2488 9.83566 10.9551 9.54191 10.9551 9.17998C10.9551 8.81804 11.2488 8.52429 11.6108 8.52429H14.2335C14.5954 8.52429 14.8892 8.81804 14.8892 9.17998C14.8892 9.54191 14.5954 9.83566 14.2335 9.83566Z",
  fill: "#388E3C"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2335 12.4585H11.6108C11.2488 12.4585 10.9551 12.1647 10.9551 11.8028C10.9551 11.4408 11.2488 11.1471 11.6108 11.1471H14.2335C14.5954 11.1471 14.8892 11.4408 14.8892 11.8028C14.8892 12.1647 14.5954 12.4585 14.2335 12.4585Z",
  fill: "#388E3C"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2335 15.0811H11.6108C11.2488 15.0811 10.9551 14.7874 10.9551 14.4255C10.9551 14.0635 11.2488 13.7698 11.6108 13.7698H14.2335C14.5954 13.7698 14.8892 14.0635 14.8892 14.4255C14.8892 14.7874 14.5954 15.0811 14.2335 15.0811Z",
  fill: "#388E3C"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1682 7.21298H16.8569C16.4949 7.21298 16.2012 6.91923 16.2012 6.55729C16.2012 6.19536 16.4949 5.90161 16.8569 5.90161H18.1682C18.5302 5.90161 18.8239 6.19536 18.8239 6.55729C18.8239 6.91923 18.5302 7.21298 18.1682 7.21298Z",
  fill: "#388E3C"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1682 9.83566H16.8569C16.4949 9.83566 16.2012 9.54191 16.2012 9.17998C16.2012 8.81804 16.4949 8.52429 16.8569 8.52429H18.1682C18.5302 8.52429 18.8239 8.81804 18.8239 9.17998C18.8239 9.54191 18.5302 9.83566 18.1682 9.83566Z",
  fill: "#388E3C"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1682 12.4585H16.8569C16.4949 12.4585 16.2012 12.1647 16.2012 11.8028C16.2012 11.4408 16.4949 11.1471 16.8569 11.1471H18.1682C18.5302 11.1471 18.8239 11.4408 18.8239 11.8028C18.8239 12.1647 18.5302 12.4585 18.1682 12.4585Z",
  fill: "#388E3C"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1682 15.0811H16.8569C16.4949 15.0811 16.2012 14.7874 16.2012 14.4255C16.2012 14.0635 16.4949 13.7698 16.8569 13.7698H18.1682C18.5302 13.7698 18.8239 14.0635 18.8239 14.4255C18.8239 14.7874 18.5302 15.0811 18.1682 15.0811Z",
  fill: "#388E3C"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0298 0.806964C11.8803 0.682384 11.6797 0.628618 11.4908 0.667959L0.999882 2.63501C0.689087 2.69271 0.464844 2.96285 0.464844 3.27889V17.7039C0.464844 18.0187 0.689087 18.2901 0.999882 18.3478L11.4908 20.3149C11.5302 20.3227 11.5708 20.3267 11.6115 20.3267C11.7636 20.3267 11.9118 20.2742 12.0298 20.1759C12.1806 20.0513 12.2671 19.8651 12.2671 19.671V1.31184C12.2671 1.11645 12.1806 0.931544 12.0298 0.806964Z",
  fill: "#2E7D32"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M9.4814 12.6826L7.40813 10.313L9.50501 7.61681C9.72794 7.33093 9.67549 6.91916 9.39092 6.69623C9.10635 6.4733 8.69458 6.52575 8.47034 6.81032L6.52821 9.30716L4.89162 7.43715C4.65164 7.16176 4.23725 7.13685 3.96711 7.37552C3.69434 7.61419 3.6668 8.02858 3.90547 8.30003L5.7086 10.3615L3.88056 12.7115C3.65762 12.9973 3.71008 13.4091 3.99464 13.632C4.11529 13.7252 4.25823 13.7697 4.39855 13.7697C4.59394 13.7697 4.78671 13.6832 4.91654 13.5166L6.58853 11.366L8.49526 13.5442C8.62508 13.6937 8.80605 13.7697 8.98833 13.7697C9.14176 13.7697 9.29519 13.716 9.41977 13.6071C9.69253 13.3685 9.72007 12.9541 9.4814 12.6826Z",
  fill: "#FAFAFA"
});
function SvgFileExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExcel);
export default __webpack_public_path__ + "static/media/file-excel.75b0795f370be37291d17a206a501db4.svg";
export { ForwardRef as ReactComponent };